<div class="checkbox-option">
  <label class="checkbox-label">{{ label }}</label>
       <input type="checkbox"  [value]="value" [formControl]="control" [checked]="isChecked" disabled>
</div>

